import { jsx as _jsx } from "react/jsx-runtime";
import cx from "classnames";
import styles from "./styles.module.scss";
const Button = ({ size = "medium", variant = "primary", color = "charcoal", children, href, role = "button", disabled = false, onClick, className, underlined, fullWidth, border, nutrition = false, ...rest }) => {
    const classes = cx(styles.linkButton, styles.button, styles[size], styles[variant], styles[color], className, {
        [styles.disabled]: disabled,
        [styles.border]: border,
        [styles.fullWidth]: fullWidth,
        [styles.underlined]: underlined,
        [styles.nutrition]: nutrition,
    });
    if (href) {
        return (_jsx("a", { href: href, onClick: onClick, className: classes, ...rest, children: children }));
    }
    return (_jsx("button", { className: classes, disabled: disabled, onClick: onClick, role: role, ...rest, children: children }));
};
export default Button;
